/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/enterprise/oAuth/OAuthPanel.Props" />
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";

export interface IOAuthPanelProps extends IBasePanelContentProps {}
